import { socketInstance } from "../socket/socket";
import { Message, MessageList } from "../types/MessageListType";
import { socketQuery } from "./socketQueries";

export type PinnedCatalogRes = {
  chat_id: number;
  pinned_messages: MessageList & { complete?: boolean };
  complete?: boolean;
  error?: string;
  request_id?: string;
};

function diskKey(chatId: number) {
  return `lyke_pin_catalog_${chatId}`;
}

/** Warm pin bar from disk without wiping on empty network glitch. */
export function readPinnedCatalogDisk(chatId: number): Message[] | null {
  try {
    const raw = localStorage.getItem(diskKey(chatId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.Records)) return null;
    return parsed.Records as Message[];
  } catch {
    return null;
  }
}

export function writePinnedCatalogDisk(chatId: number, records: Message[]) {
  try {
    localStorage.setItem(
      diskKey(chatId),
      JSON.stringify({ Records: records, savedAt: Date.now() }),
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearPinnedCatalogDisk(chatId: number) {
  try {
    localStorage.removeItem(diskKey(chatId));
  } catch {
    /* ignore */
  }
}

export async function fetchPinnedMessages(params: {
  chat_id: number;
  page?: number;
  pageSize?: number;
}): Promise<PinnedCatalogRes> {
  return (await socketQuery(
    socketInstance(),
    "get_pinned_messages",
    {
      chat_id: params.chat_id,
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 50,
    },
    "get_pinned_messages",
  )) as PinnedCatalogRes;
}

export function isPinnedCatalogAuthoritative(
  payload: {
    complete?: boolean;
    pinned_messages?: { complete?: boolean; Records?: unknown };
  } | null | undefined,
): boolean {
  if (!payload || typeof payload !== "object") return false;
  if (payload.complete === true) return true;
  if (payload.pinned_messages?.complete === true) return true;
  return false;
}
